export const verification_intro = {
  title: "Verify your email",
  link_login: "Sign in instead",
};

export const verification_verified = {
  title: "You are already verified",
  cta_continue: "Continue",
};
